<template>
  <div :class="[defaultClasses ? 'custom-select-wrap' : 'custom-select-wrap-vue', 
                { active: isActive, 'single-list': options.length < 2, 'empty-text': filteredOptions.length === 0, disabled: isDisabled }]" 
       tabindex="0" 
       @keydown="handleKeydown" 
       @focusout="handleFocusout"
  >
    <div :class="[defaultClasses ? 'fake-select' : 'fake-select-vue', {'select-ico': hasIcon,'has-search': hasSearch, [classIcon]: !!classIcon}]" @click="toggleSelect">
      <div :class="['value', { 
          chosen: selectedOption, 
          default: !selectedOption || modelValue === 0 || modelValue === '' 
        }]">
        <div class="value__img" v-if="selectedIcon && hasIconsMask" :style="{
            WebkitMaskImage: `url(${selectedIcon})`,
            maskImage: `url(${selectedIcon})`
          }"></div>
        <img v-else-if="selectedIcon" :src="selectedIcon" :alt="selectedText" />
        <div class="sub-value">
          <input v-if="hasSearch" autocomplete="off" v-model="searchQuery" class="search-input" :placeholder="searchLabel" @keyup="performSearch" />
          <span class="sub-value__label" v-html="selectedText"></span>
          <span v-if="selectedOption && selectedOption.addition" class="addition">{{ selectedOption.addition }}</span>
        </div>
      </div>
      <span class="ico-arrow"></span>
    </div>
    <div :class="[defaultClasses ? 'options-list-wrap' : 'options-list-wrap-vue', { 'with-search': hasSearch, 'empty-text': filteredOptions.length === 0 }]">
      <i v-if="hasSearch" :class="['far fa-times-circle', { show: filteredOptions.length === 0 && isActive}]" @click="clearSearch"></i>
      <ul class="options-list" ref="optionsList" @scroll="handleScroll" @click="toggleSelect">
        <li v-for="option in filteredOptions" 
            :class="{ active: option.value === modelValue, default: option.value === 0 || option.value === '' }" 
            :key="option.value" 
            :data-letter="option.text[0].toLowerCase()" 
            :value="option.value" 
            @click="selectOption(option)"
          >
          <span class="select-li-text">
            <div class="value">
              <div class="value__img" v-if="option.icon && hasIconsMask" :style="{
                  WebkitMaskImage: `url(${option.icon})`,
                  maskImage: `url(${option.icon})`
                }"></div>
              <img v-else-if="option.icon" :src="option.icon" alt="icon" />
              <div class="sub-value">
                <div v-html="option.text"></div>
                <span v-if="option.addition" class="addition">{{ option.addition }}</span>
              </div>
            </div>
          </span>
        </li>
      </ul>
    </div>
    <div v-if="hasSearch && filteredOptions.length === 0" :class="['empty', { show: filteredOptions.length === 0 && isActive}]">{{ emptyText }}</div>
    <select ref="selectElement" :name="selectName" :value="modelValue" @change="emitChange" style="display: none;">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  emits: ['selectOpened', 'selectClosed', 'update:modelValue'],
  props: {
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    searchLabelProps: {
      type: [String, Boolean],
      default: false,
      required: false,
    },
    emptyTextProps: {
      type: [String, Boolean],
      default: false,
      required: false,
    },
    hasSearch: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
      required: false,
    },
    hasIconsMask: {
      type: Boolean,
      default: false,
    },
    classIcon: {
      type: String,
      default: '',
      required: false,
    },
    defaultClasses: {
      type: Boolean,
      default: false,
    },
    selectName: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isActive: false,
      searchLabel: this.searchLabelProps.length ? this.searchLabelProps : this.$t('Search...'),
      emptyText: this.emptyTextProps.length ? this.emptyTextProps : this.$t('No results for your request'),
      searchQuery: '',
      filteredOptions: this.options,
      selectedOption: null,
      localOptions: []
    };
  },
  computed: {
    selectedText() {
      return this.selectedOption ? this.selectedOption.text : '';
    },
    selectedIcon() {
      if (this.selectedOption && this.selectedOption?.icon_active) {
        return this.selectedOption?.icon_active
      } else if (this.selectedOption && this.selectedOption.icon) {
        return this.selectedOption.icon;
      } else {
        return ''
      }
    },
    isDisabled() {
      return this.$refs.selectElement && this.$refs.selectElement.disabled;
    }
  },
  watch: {
    searchQuery(val) {
      this.performSearch();
    },
    modelValue(newVal) {
      this.selectedOption = this.localOptions.find(option => option.value == newVal);
      this.filteredOptions = this.localOptions;
    },
    options: {
      handler(newOptions) {
        this.localOptions = [...newOptions];
        this.filteredOptions = [...newOptions];
        this.selectedOption = newOptions.find(o => o.value == this.modelValue) || null;
      },
      deep: true,
      immediate: true,
    },
    isActive(val) {
      const list = this.$refs.optionsList;
      const parentWrap = list.closest('.options-list-wrap-vue');
      if (val) {
        let listHeight = list.scrollHeight;
        if(listHeight > 240) listHeight = 240;
        if (parentWrap) {
          parentWrap.style.maxHeight = `${listHeight}px`;
        }
        this.$emit('selectOpened');
      } else {
        parentWrap.style.maxHeight = `0px`;
        this.$emit('selectClosed');
      }
    }
  },
  methods: {
    toggleSelect() {
      if (this.isDisabled) return;
      this.isActive = !this.isActive;
      
      if (this.isActive) {
        this.$nextTick(() => {
          this.handleScroll();

          const list = this.$refs.optionsList;
          const activeEl = list?.querySelector('li.active');
          if (activeEl && list) {
            const offsetTop = activeEl.offsetTop;
            const listHeight = list.scrollHeight;
            const itemHeight = activeEl.clientHeight;
            list.scrollTop = offsetTop - (listHeight / 2) + (itemHeight / 2);
          }

          if (this.hasSearch) {
            this.$el.querySelector('.search-input')?.focus();
          }
        });
      } else {
        this.clearSearch();
      }
    },
    handleKeydown(event) {
      const key = event.keyCode;
      if ([13, 32].includes(key) && !this.isActive) {
        event.preventDefault();
        this.toggleSelect();
      } else if (this.isActive) {
        let currentIndex = this.filteredOptions.findIndex(option => option.value == this.modelValue);
        if (key === 40 && currentIndex < this.filteredOptions.length - 1) {
          event.preventDefault();
          this.selectOption(this.filteredOptions[currentIndex + 1]);
        } else if (key === 38 && currentIndex > 0) {
          event.preventDefault();
          this.selectOption(this.filteredOptions[currentIndex - 1]);
        } else if (key === 13 || key === 32) {
          event.preventDefault();
          this.toggleSelect();
        }
      }
    },
    handleFocusout() {
      setTimeout(() => {
        if (!this.$el.contains(document.activeElement)) {
          this.clearSearch();
          this.isActive = false;
        }
      }, 1);
    },
    clearSearch() {
      this.searchQuery = '';
      this.filteredOptions = this.localOptions;
    },
    performSearch() {
      const query = this.searchQuery.toLowerCase().trim();
      this.filteredOptions = this.localOptions.filter(option =>
        option.text.toLowerCase().includes(query) ||
        (option.additionSearch && option.additionSearch.toLowerCase().includes(query))
      );
    },
    selectOption(option) {
      this.$emit('update:modelValue', option.value);
      this.clearSearch();
      setTimeout(()=>{
        this.isActive = false;
      },100)
    },
    emitChange() {
      this.$emit('change', this.modelValue);
    },
    handleScroll() {
      const list = this.$refs.optionsList;
      const scrollHeight = list.scrollHeight;
      const scrollTop = list.scrollTop;
      const clientHeight = list.clientHeight;

      if (scrollHeight > clientHeight + 1) {
        list.classList.add('faded');
      } else {
        list.classList.remove('faded');
      }

      if (scrollTop > 0) {
        list.classList.add('faded-top');
      } else {
        list.classList.remove('faded-top');
      }

      if (scrollTop + clientHeight < scrollHeight - 1) {
        list.classList.add('faded');
      } else {
        list.classList.remove('faded');
      }
    }
  },
  mounted() {
    this.selectedOption = this.options.find(option => option.value == this.modelValue) || null;
    
    this.filteredOptions = this.options;
  },
};
</script>


<style scoped lang="scss">
.custom-select-wrap-vue {
  position: relative;
  text-align: left;

  .fake-select-vue {
    display: flex;
    align-items: center;
    line-height: 32px;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    color: #505050;
    font-weight: 400;
    width: 100%;
    min-height: 56px;
    background: #fff;
    cursor: pointer;
    padding: 11px 40px 10px 13px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    z-index: 2;
    transition: 0.5s all;
    &:hover{
      @media only screen and (min-width: 768px) {
        border: 1px solid #9D9D9D;
      }
    }
    .sub-value,
    .value {
      overflow: hidden;
      color: #505050;
      font-family: "Avenir-Next", sans-serif;
      font-weight: 100;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      width: 100%;
      text-transform: capitalize;
      &.default{
        span{
          color: #9ba1ab;
        } 
      }
      span{
        color: #505050;
        font-family: "Avenir-Next", sans-serif;
        font-weight: 100;
        font-size: 16px;
        line-height: 24px;
        transition: 0.4s all;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        float: left;
        border-radius: 2px;
      }
      &__img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        float: left;
        border-radius: 2px;
        transition: 0.4s all;
        background-color: #505050;
        mask-repeat: no-repeat;
        mask-size: 100%;
        mask-position: 0 bottom;
      }
    }
    &.has-search{
      padding: 0 40px 0 13px;
      overflow: visible;
      .sub-value{
        &__label{
          position: absolute;
          top: 15px;
          left: 45px;
          color: #505050;
          font-family: "Avenir-Next", sans-serif;
          font-weight: 100;
          font-size: 16px;
          line-height: 24px;
          text-transform: none;
          transition: 0.5s, color 
            ease-in-out 0.15s;
          padding: 0 3px;
          border-radius: 12px;
          max-width: 100%;
          overflow: hidden;
        }
      }
      .search-input {
        display: block;
        width: calc(100% - 34px);
        color: transparent;
        border: none !important;
        padding: 0 15px 0 34px;
        height: 100%;

        &:hover,
        &:focus {
          background-color: inherit !important;
          color: #1F1F1F;
          & + .sub-value__label {
            top: -10px;
            left: 13px;
            font-size: 12px;
            background: #fff;
          }
        }
        
        &::placeholder {
          color: transparent !important;
        }
      }
    }

    .control-label {
      display: none;
    }

    .ico-arrow {
      width: 24px !important;
      height: 24px !important;
      margin-top: 0 !important;
      right: 15px !important;
      top: auto;
      transform: translateY(-50%);
      transform-origin: center center;
      &::before {
        width: 24px !important;
        height: 24px !important;
        background: url("/webpack-assets/img/icons/angle-down.svg") center center no-repeat;
        border: none !important;
        transition: 0.2s;
        content: "";
      }
      &::after {
        position: absolute;
        left: 0;
        opacity: 0;
        content: "";
        display: block;
        width: 24px !important;
        height: 24px !important;
        background: url("/webpack-assets/img/icons/angle-down_blue.svg") center center
          no-repeat;
        border: none !important;
        transition: 0.2s;
      }
    }
  }

  .options-list-wrap-vue {
    display: block;
    position: absolute;
    width: 100%;
    height: auto;
    max-height: 0;
    transition: 0.5s all;
    overflow: hidden;
    border-radius: 8px;
    z-index: 12;
    top: 58px;
    background: #fff;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .15), 0 4px 4px 0 rgba(0, 0, 0, .25);

    .fa-times-circle {
      position: absolute;
      top: 25px;
      right: 30px;
      font-size: 18px;
      cursor: pointer;
      display: none;
      color: #000;
    }

    .magnifier {
      position: absolute;
      top: 25px;
      left: 30px;
      width: 20px;
      height: 20px;
      background-size: contain;
      cursor: pointer;
      display: block;
      color: #000;
    }

    .options-list {
      max-height: 240px;
      overflow-y: auto;
      overflow-x: auto;
      position: relative;

      &::-webkit-scrollbar {
        width: 5px;
        background: transparent;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #4e8aff;
        width: 5px;
        height: 1em;
        border-radius: 5px;
      }

      li {
        padding: 10px 13px;
        color: #9d9d9d;
        background: transparent;
        cursor: pointer;
        display: block;
        font-size: 14px;
        border: none;
        font-weight: 400;
        text-transform: none;
        transition: 0.4s;
        //-webkit-mask-image: linear-gradient(90deg, black 90%, transparent);
        .value{
          display: flex;
          align-items: center;
          .sub-value{
            min-width: 0;
            width: 100%;
            div{
              font-family: "Avenir-Next";
              font-weight: 400;
              font-size: 16px;
              leading-trim: NONE;
              line-height: 24px;
              white-space: nowrap;
              text-transform: capitalize;
              overflow: hidden;
              width: 100%;
              -webkit-mask-image: linear-gradient(90deg, black 90%, transparent);
            }
          }
          img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
            float: left;
            border-radius: 2px;
          }
          .value__img{
            height: 24px;
            width: 24px;
            margin-right: 10px;
            float: left;
            border-radius: 2px;
            transition: 0.4s all;
            background-color: #9d9d9d;
            mask-repeat: no-repeat;
            mask-size: 100%;
            mask-position: 0 bottom;
          }
        }

        &:hover,
        &:focus {
          background: rgba(78, 138, 255, .1);
          border: none;
          color: #1f1f1f;
          .value__img{
            background-color: #1f1f1f;
          }
        }
        &.default{
            background-color: #4E8AFF1A;
            color: #1F1F1F;
        }
        &.active {
          background: rgba(78, 138, 255, .2);
          border: none;
          .sub-value{
            color: #4e8aff;
          }
          .value__img{
            background-color: #4e8aff;
          }
          &:hover {
            color: #1f1f1f;
          }
        }
      }
    }
  }
  .empty{
      background: #fff;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .15), 0 4px 4px 0 rgba(0, 0, 0, .25);
      border-radius: 8px;
      padding: 15px;
  }
  &.active {
    .fake-select-vue {
      border: 1px solid #4e8aff !important;
      box-shadow: 0 0 5px #4e8aff33;
      .sub-value .sub-value__label{
        color: #4e8aff;
      }
      .value__img{
        background-color: #4e8aff;
      }
    }
    .options-list-wrap {
      z-index: 13;
      max-height: 284px !important;
    }
    .ico-arrow {
      &::before {
        transform: scale(1, -1);
      }
      &::after {
        transform: scale(1, -1);
        opacity: 1;
      }
    }
    .fake-select {
      border: 1px solid #4e8aff !important;
      background: #fff !important;
      box-shadow: none !important;
    }

    .control-label {
      font-size: 12px;
      top: -13px;
      background: #fff;
      color: #4e8aff !important;
    }
  }
  &.single-list {
    pointer-events: none;
    .ico-arrow {
      display: none;
    }
  }
}
</style>